import { render, staticRenderFns } from "./suspensioncom.vue?vue&type=template&id=79f06bac&scoped=true&"
import script from "./suspensioncom.vue?vue&type=script&lang=js&"
export * from "./suspensioncom.vue?vue&type=script&lang=js&"
import style0 from "./suspensioncom.vue?vue&type=style&index=0&id=79f06bac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f06bac",
  null
  
)

export default component.exports